import { render, staticRenderFns } from "./StepIdentifier.vue?vue&type=template&id=78db2961&"
import script from "./StepIdentifier.vue?vue&type=script&lang=js&"
export * from "./StepIdentifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports